.root {
  overflow-x: auto;
}

.root-table {
  border-collapse: collapse;
  min-width: 560px;
  width: 100%;
}

.root-head {
  font-size: 13px;
  font-weight: 500;
  padding: 0 8px 8px;
  text-align: left;
}

.root-label {
  font-size: 13px;
  font-weight: 500;
  padding: 6px 12px 6px 0;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
}

.root-rate {
  color: var(--color-muted);
  font-size: 13px;
  padding: 6px 8px;
}

.root-input {
  padding: 6px 8px;
  vertical-align: top;
}

.root-result {
  border-top: 1px solid var(--color-border);

  th,
  td {
    color: inherit;
    font-weight: 600;
    padding-top: 10px;
  }
}

.root-error {
  color: var(--color-error);
  display: block;
  font-size: 12px;
  margin-top: 4px;
}

.root-hidden {
  clip: rect(0 0 0 0);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
